import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const ease = [0.16, 1, 0.3, 1];

const FRAGMENT_IMG =
  "https://customer-assets.emergentagent.com/job_capital-motion/artifacts/69it920t_ChatGPT%20Image%20Apr%2028%2C%202026%2C%2012_50_05%20AM.png";

const services = [
  {
    n: "01",
    title: "Private Banking",
    body: "Multi-currency private accounts, real-time settlement, biometric security — managed from one calm dashboard.",
  },
  {
    n: "02",
    title: "Premium Cards",
    body: "Discreet metal cards through regulated banking partners. Biometric controls, instant freeze, full discretion across 200+ markets.",
  },
  {
    n: "03",
    title: "Investments & Analytics",
    body: "Track hedge fund exposures, monitor performance, access curated investment opportunities — consolidated into one view.",
  },
];

export default function Services() {
  return (
    <section
      id="capital"
      className="relative bg-[#EFEDE7] text-[#15161A] py-32 sm:py-40 lg:py-48"
      data-testid="services-section"
    >
      {/* corner labels */}
      <div className="absolute top-8 left-6 sm:left-10 lg:left-12 t-mono text-[#15161A]/55">
        — § 05 / Services
      </div>
      <div className="absolute top-8 right-6 sm:right-10 lg:right-12 t-mono text-[#15161A]/55">
        Three offerings
      </div>

      <div className="max-w-[1700px] mx-auto px-6 sm:px-10 lg:px-12">
        {/* Hero gallery card — OFFTHEGRID style */}
        <div className="grid grid-cols-12 gap-6 lg:gap-10 mb-24 sm:mb-32">
          <div className="col-span-12 md:col-span-4 self-end md:pb-4">
            <div className="t-mono text-[#15161A]/55 mb-3">— Curated</div>
            <h3 className="t-display text-[#15161A] text-3xl sm:text-4xl lg:text-5xl leading-[0.98] tracking-[-0.04em]">
              Browse our set of services &amp; offerings.
            </h3>
            <p className="mt-5 t-body text-sm text-[#15161A]/65 leading-relaxed max-w-sm">
              Three pillars of the platform — explore each on its own, or have
              a relationship manager walk you through the whole ecosystem.
            </p>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 1.6, ease }}
            className="col-span-12 md:col-span-8 frame-cream relative aspect-[4/3] md:aspect-[16/11] overflow-hidden"
          >
            <img
              src={FRAGMENT_IMG}
              alt="Off the grid — gallery"
              className="w-full h-full object-cover object-center"
              draggable="false"
            />
            <div className="absolute top-5 left-6 t-mono text-[#15161A]/70">
              Track simply
            </div>
            <div className="absolute bottom-5 left-6 t-mono text-[#15161A]/55">
              Hand-cut · stone &amp; type
            </div>
          </motion.div>
        </div>

        {/* Services list */}
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-3 t-mono text-[#15161A]/55">
            — Three offerings
          </div>
          <div className="col-span-12 md:col-span-9 border-t border-[#C9C5BB]">
            {services.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10% 0px" }}
                transition={{ duration: 0.9, ease, delay: i * 0.08 }}
                className="grid grid-cols-12 items-baseline py-10 gap-6 border-b border-[#C9C5BB] group hover:bg-[#E5E2DA]/60 transition-colors px-2 -mx-2 rounded"
                data-testid={`service-row-${s.n}`}
              >
                <span className="col-span-2 t-mono text-[#15161A]/55">{s.n}</span>
                <span className="col-span-10 md:col-span-4 t-display text-[#15161A] text-2xl sm:text-3xl tracking-[-0.03em]">
                  {s.title}
                </span>
                <span className="col-span-12 md:col-span-5 t-body text-sm text-[#15161A]/70 leading-relaxed">
                  {s.body}
                </span>
                <ArrowUpRight className="hidden md:block col-span-1 w-4 h-4 justify-self-end text-[#15161A]/45 group-hover:text-[#15161A] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" strokeWidth={1.4} />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
